import React, { useEffect, useState, useRef } from 'react'
import Logo from '../../Assets/images/main-logo.svg'
import microsoft from "../../Assets/images/microsoft.svg"
import google from "../../Assets/images/google.svg"
import apple from "../../Assets/images/apple-icon.svg"
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup';
import { ErrorMessage } from '@hookform/error-message';
import RegisterValidation from '../../Validation/SignupValidation'
import useMakeRequest from '../../utils/ApiHelper'
import { ApiConstants } from '../../constants/ApiConstants'
import { Link, useNavigate } from 'react-router-dom'
import { Modal } from 'react-bootstrap'
import { getBrowserType, handleBackspaceAndEnter, saveToStorage } from '../../utils/Helper'
import { Config } from '../../config/Config'
import CommanPhoneNumber from '../layout/CommanPhoneNumber'
import SocialLogin from '../layout/SocialLogin'
import FrontLoader from '../layout/FrontLoader'
import { LanguageConstants } from '../../constants/LanguageConstants'
// import SocialLogin from 'reactjs-social-login';
// import { GoogleLoginButton } from 'reactjs-social-login-buttons';


interface FormInputs {
  name: string,
  email: string;
  password: string;
  phone_number:string;
  confirm_password: string,
  agree: boolean;
  phone_country_code:string
};

function Signup() {
  const numberOfDigits = 4;
  const regex = /^[0-9\b]+$/;
  const otpBoxRef = useRef<any>([]);
  const navigate = useNavigate()
  const Register = useMakeRequest()
  const ResedOtp = useMakeRequest()
  const OTP = useMakeRequest()
  let countdown: any;
  const [otppopu, setOtpPopu] = useState(false)
  const [show, setShow] = useState(false)
  const [cshow, setCshow] = useState(false)
  const [otpData, setOtpData]: any = useState('')
  const [otpError, setOtpError] = useState('');
  const [otp, setOtp]: any = useState(new Array(numberOfDigits).fill(""));
  const [tempdata, setTempdata] = useState<any>({})
  const [timer, setTimer] = useState(120);
  const [isTimerRunning, setIsTimerRunning] = useState(false);
  const { register, watch, setValue, formState: { errors }, handleSubmit } = useForm<FormInputs>({
    mode: 'onChange',
    defaultValues: {
      phone_country_code: "+1",
    },
    resolver: yupResolver(RegisterValidation),
  });

  const onSubmit = (payload: FormInputs) => {
    setTempdata(payload)
    Register.makeRequest({ payload, url: ApiConstants?.Register, toastStatus: true })
  }

  useEffect(() => {
    if (Register?.status) {
      setOtpPopu(true)
      setTimer(120)
      setIsTimerRunning(false)
      setIsTimerRunning(true)
      setOtpError('')
    }
    if (OTP?.status) {
      saveToStorage({ key: "access_token", value: OTP?.data?.access_token })
      saveToStorage({ key: "user_data", value: OTP?.data })

      
      window.location.href = `${Config?.BASE_URL}/`;
      // navigate('/')
    }
  }, [Register.status, OTP.status])

  const onPaste = (event: any) => {
    const pasted = event.clipboardData.getData("text/plain")
    if (pasted.length === numberOfDigits && regex.test(pasted)) {
      setOtpError('')
      setOtpData(pasted)
      setOtp(pasted.split("").slice(0, numberOfDigits))
    }

  }
  const handleChange = (value: any, index: any) => {
    setOtpError('')
    if (value === '' || regex.test(value)) {
      let newArr = [...otp];
      newArr[index] = value;
      setOtp(newArr);
      setOtpData(newArr.join(''))

    }

    if (value && regex.test(value) && index < numberOfDigits - 1) {
      otpBoxRef.current[index + 1].focus();
    }
  }
  const handleKeyDown = (event: any) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      // handleVerify()
    }
  }
  const handleVerify = () => {
    if (otp.join("") == "" || otpData?.length < 4) {
      return setOtpError('Please enter OTP.')
    }
    setOtpError('');
    let payload = {
      email: tempdata?.email,
      otp: otpData,
      verify_type: "MAIL_VERIFY"
    }
    OTP.makeRequest({ payload, url: ApiConstants?.VerifyOtp, toastStatus: true })
  }
  useEffect(() => {
    if (isTimerRunning && timer > 0) {
      countdown = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    } else if (timer === 0) {
      clearInterval(countdown);
      setIsTimerRunning(false);
    }
    return () => {
      clearInterval(countdown);
    };
  }, [isTimerRunning, timer]);

  useEffect(()=>{
    if(ResedOtp.status){
      setIsTimerRunning(true)
      setTimer(120)
    }
    },[ResedOtp?.status])
    
    
    const handelResendOtp =()=>{
      const payload ={
        email:watch('email'),
        verify_type:'MAIL_VERIFY'
      }
      ResedOtp.makeRequest({ payload, url: ApiConstants?.ResendOtp, toastStatus: true })
    }

    const handlePhoneNumber = (value: any, code: any, phone: any) => {
      console.log(value)
      const country_code = `+${value}`
      setValue('phone_country_code', country_code);
  }


  return (
    <>
    {(ResedOtp?.loading || Register?.loading || OTP?.loading) ? <FrontLoader/> :null}
      <div className="auth-page">
        <div className="auth-page-form">
          <div className="auth-form-inner">
            <a className="auth-logo" href={`${Config?.BASE_URL}/`}><img src={Logo} /></a>
            <h1 className="auth-title">{LanguageConstants?.SINGUP}</h1>
            <p className="auth-head-para">{LanguageConstants?.ENTER_YOUR_DETAILS}</p>
            <form onSubmit={handleSubmit(onSubmit)} >
              <div className="row">
                <div className='col-xl-6'>
                  <div className='mb-4'>
                    <div className="com-floating">
                      <i className="f-icon icon-user" />
                      <label className="f-label">{LanguageConstants?.NAME} <span className="must-star">*</span></label>
                      <input className="f-input" type="text" placeholder={LanguageConstants?.NAME}    {...register('name')} />
                    </div>
                    <ErrorMessage
                      errors={errors}
                      name="name"
                      render={({ message }) => <p className='text-error'>{message}</p>}
                    />
                  </div>
                </div>
                <div className="col-xl-6">
                  <div className='mb-4'>
                    <div className="com-floating">
                      <i className="f-icon icon-msg" />
                      <label className="f-label">{LanguageConstants?.LOGIN_EMAIL_ADDRESS}<span className="must-star">*</span></label>
                      <input className="f-input" type="email" placeholder={LanguageConstants?.LOGIN_EMAIL_ADDRESS_TEXT} {...register('email')} />
                    </div>
                    <ErrorMessage
                      errors={errors}
                      name="email"
                      render={({ message }) => <p className='text-error'>{message}</p>}
                    />

                  </div>
                </div>
                {/* <div className="col-md-6">
                  <CommanPhoneNumber   handleMobileNumber={handlePhoneNumber}  />
                  <ErrorMessage
                        errors={errors}
                        name="phone_country_code"
                        render={({ message }) => <p className='text-error'>{message}</p>}
                      />
                </div> */}
                <div className='wrap-phn-code'>
                  <CommanPhoneNumber   handleMobileNumber={handlePhoneNumber} value={watch('phone_country_code')} />
                  <input className='wrap-phn-input' type="text" {...register('phone_number')}/>
                </div>
                <ErrorMessage
                      errors={errors}
                      name="phone_number"
                      render={({ message }) => <p className='text-error'>{message}</p>}
                    />
                {/* <div className="col-md-6">
                  <div className='mb-4'>
                    <div className="com-floating">
                      <i className="f-icon icon-msg" />
                      <label className="f-label">Phone Number <span className="must-star">*</span></label>
                      <input className="f-input" type="text" placeholder="Enter phone number" {...register('phone_number')} />
                    </div>
                    <ErrorMessage
                      errors={errors}
                      name="phone_number"
                      render={({ message }) => <p className='text-error'>{message}</p>}
                    />

                  </div>
                </div> */}
              </div>
              <div className="row">
                <div className="col-xl-6">
                  <div className='mb-4'>
                    <div className="com-floating">
                      <i className="f-icon icon-lock" />
                      <label className="f-label">{LanguageConstants?.PASSWORD} <span className="must-star">*</span></label>
                      <input className="f-input" type={cshow ? "text" : 'password'} placeholder={LanguageConstants?.PASSWORD} {...register('password')} />
                      <i className={cshow ? "f-pass icon-eye-open" : "f-pass icon-eye-slash-fill"} onClick={() => setCshow(!cshow)}></i>
                    </div>
                    <ErrorMessage
                      errors={errors}
                      name="password"
                      render={({ message }) => <p className='text-error'>{message}</p>}
                    />
                  </div>
                </div>
                <div className="col-xl-6">
                  <div className='mb-4'>
                    <div className="com-floating">
                      <i className="f-icon icon-lock" />
                      <label className="f-label">{LanguageConstants?.Confirm_Password}<span className="must-star">*</span></label>
                      <input className="f-input" type={show ? "text" : 'password'} placeholder={LanguageConstants?.Confirm_Password} {...register('confirm_password')} />
                      <i className={show ? "f-pass icon-eye-open" : "f-pass icon-eye-slash-fill"} onClick={() => setShow(!show)}></i>

                    </div>
                    <ErrorMessage
                      errors={errors}
                      name="confirm_password"
                      render={({ message }) => <p className='text-error'>{message}</p>}
                    />

                  </div>
                </div>
              </div>
              <div className="form-label-area">
                <div className="form-check">
                  <input className="form-check-input" type="checkbox" id="rememberMe" {...register('agree')} />
                  <label className="form-check-label" htmlFor="rememberMe">
                   {LanguageConstants?.IAGREEWITH} {''}
                    <Link to={"/cms/privacy-policy"}  >{LanguageConstants?.PRIVACY_POLICY}</Link>  & <Link to={"/cms/terms-and-conditions"} > {LanguageConstants?.TERMS_SINGUP} &amp; {LanguageConstants?.Condition}</Link>
                    <ErrorMessage
                      errors={errors}
                      name="agree"
                      render={({ message }) => <p className='text-error mt-0'>{message}</p>}
                    />
                  </label>
                </div>
              </div>
              <button className="com-btn w-100 form-submit-btn">{LanguageConstants?.SINGUP}</button>
                            <div className="small-txt text-center mt-3">{LanguageConstants?.GUEST_USER}   <Link to={'/'} className="theme-color" >{LanguageConstants?.GUEST}</Link></div>
              {/* <div className="small-txt text-center mt-5">Continue as a <a className="theme-color text-decoration-underline" href="#">Guest</a></div> */}
             <SocialLogin/>
              <div className="small-txt text-center mt-5">{LanguageConstants?.HAVE_ACCOUNT} ?
                <Link to={'/login'} className="theme-color text-decoration-underline" >   {LanguageConstants?.LOGIN}</Link></div>
            </form>
          </div>
        </div>
        <div className="auth-page-bnr" />
      </div>


      {/* <!-- OTP verify modal --> */}
      <Modal show={otppopu}>
        <div className="modal fade auth-modal text-center show" id="forgotPassModal" aria-labelledby="forgotPassModalLabel" aria-hidden="false" style={{ display: 'block' }} >

          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <button type="button" onClick={() => setOtpPopu(false)} className="btn-close" data-bs-dismiss="modal" aria-label="Close"><i className="icon-close-square"></i></button>
              <div className="modal-body">
                <h5 className="auth-modal-ttl mb-2">{LanguageConstants?.OTP_VERIFICATION}</h5>
                <p className="auth-modal-small-txt">{LanguageConstants?.ENTER_OTP_DIGIT} ****{tempdata?.email?.split('@')[1]}</p>
                <div className="otp-inputs">
                  {
                    otp.map((digit: any, index: any) => {
                      return (
                        <input className='form-control' key={index}
                          value={digit} onPaste={onPaste} maxLength={1} ref={(ref) => (otpBoxRef.current[index] = ref)}
                          type="text"
                          placeholder="*"
                          onChange={(e) => handleChange(e.target.value, index)}
                          onKeyDown={handleKeyDown}
                          onKeyUp={(e) => handleBackspaceAndEnter(e, index, otpBoxRef, numberOfDigits)}
                        />
                      )
                    })
                  }
                </div>
                <p style={{ color: 'red' }} >{otpError}</p>
                <p className="auth-modal-small-txt mb-2">{LanguageConstants?.DONT_RECIVE_CODE}?</p>
                {isTimerRunning ?  
                <div className="auth-modal-small-txt border-0 fw-500 p-0 bg-transparent theme-color mb-4">{LanguageConstants?.RESEND_IN} :{timer} s</div>
                :
                <button className="auth-modal-small-txt border-0 fw-500 p-0 bg-transparent theme-color mb-4" onClick={()=>handelResendOtp()}>{LanguageConstants?.RESEND_OTP}</button>
                }
                <button type="button" onClick={handleVerify} className="auth-modal-btn round-btn mt-4 w-50 d-block mx-auto" data-bs-dismiss="modal">{LanguageConstants?.VERIFY}</button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
      {/* <!-- OTP verify modal --> */}
    </>
  )
}

export default Signup


